export default {
  buttonText: "Subscribe",
  callToJoin: "Join millions of other fans!",
  header: "Subscribe today for $8.33/Month",
  redirectMessage:
    "Members get exclusive access to Rivals FanFutureCast, forums, premium articles and more!",
  subscribePath: "/subscribe",
  valueProp1: "Members-only forums",
  valueProp2: "Predict prospect commits with FanFutureCast",
  valueProp3: "Exclusive highlights and interviews",
  valueProp4: "Exclusive coverage of Rivals Camp Series",
  valueProp5: "Breaking recruiting news"
};
